import { CitizenshipStatusEnum } from '@interfaces/open-account/enums';
import { Action, createReducer, on } from '@ngrx/store';
import { IDPSResponse, IDPSState, YesNoEmpty } from '@shared/models';
import { CitizenshipStatus } from 'vg-interaction-model/dist';
import { IPersonalInfoClientState } from 'vg-interaction-model/dist/lib/features/personal-info-client/store/reducers/personal-info-client.reducer';

import * as PersonalDataActions from '../../actions/personal-data/personal-data.actions';

// TODO-Personal Info Refactor: remove the OVV data from this state, should only be saved to VGIM state
export interface PersonalDataState {
  birthDate: string;
  citizenship: string;
  firstName: string;
  middleName: string;
  lastName: string;
  tin_private: string;
  contactInfo: {
    primaryEmailAddress: string;
  };
  phoneNumber: string;
  isMobile: boolean;
  loaded: boolean;
  segment: string;
  incapacitated: boolean;
  digitalAdviseService: boolean;
}

export const initialState: PersonalDataState = {
  birthDate: '',
  citizenship: '',
  firstName: '',
  middleName: '',
  lastName: '',
  tin_private: '',
  contactInfo: {
    primaryEmailAddress: '',
  },
  phoneNumber: '',
  isMobile: false,
  loaded: false,
  segment: '',
  incapacitated: false,
  digitalAdviseService: false,
};

const personalDataReducer = createReducer(
  initialState,
  on(PersonalDataActions.LoadPersonalDataSuccess, (state) => ({
    ...state,
    loaded: true,
  })),
  on(PersonalDataActions.LoadPersonalDataPayloadSuccess, (state, prop) => ({
    ...state,
    ...prop.payload,
    loaded: true,
  })),
  on(PersonalDataActions.LoadPersonalDataClientFail, (state) => ({
    ...state,
    loaded: false,
  })),

  on(PersonalDataActions.RedirectToPVR, (state) => ({
    ...state,
    loaded: false,
  })),
  on(PersonalDataActions.UpdateClientSegment, (state, prop) => ({
    ...state,
    segment: prop.payload,
  })),
  on(PersonalDataActions.UpdateClientFlagDigitalAdvise, (state, prop) => ({
    ...state,
    digitalAdviseService: prop.payload,
  })),
);

export function reducer(state: PersonalDataState | undefined, action: Action) {
  return personalDataReducer(state, action);
}

export const getLast4IdOnFile = (state: PersonalDataState) => {
  if (state.tin_private.length === 9) {
    return state.tin_private.substring(5);
  }
  return null;
};

export const getClientSegment = (state: PersonalDataState) => state.segment;

export const getClientIncapacitated = (state: PersonalDataState) => state.incapacitated;

export function formatProspectAddressData(state: IDPSResponse) {
  const formatted = {
    streetAddress: {
      ...state.contactInfo.streetAddress,
    },
    mailingAddress: {
      ...state.contactInfo.mailingAddress,
    },
    isStreetAddressSame: state.contactInfo.isStreetSameAsMailing,
  };
  return formatted;
}

export function formatCitizenshipData(citizenship: string) {
  switch (citizenship) {
    case CitizenshipStatus.UsCitizen:
    case CitizenshipStatusEnum.UsCitizen:
      return CitizenshipStatusEnum.UsCitizen;
    case CitizenshipStatus.ResidentAlien:
    case CitizenshipStatusEnum.ResidentAlien:
      return CitizenshipStatusEnum.ResidentAlien;
    case CitizenshipStatus.NonresidentAlien:
    case CitizenshipStatusEnum.NonresidentAlien:
      return CitizenshipStatusEnum.NonresidentAlien;
    default:
      return CitizenshipStatusEnum.None;
  }
}

// VGIM Personal info state
export const getClientName = (state: IPersonalInfoClientState['clientData']) =>
  [state.firstName, state.middleName, state.lastName].filter(Boolean).join(' ');

export const getClientDateOfBirth = (state: IPersonalInfoClientState['clientData']) =>
  state.birthDate ? state.birthDate : null;

export const getClientEmailAddress = (state: IPersonalInfoClientState['clientData']) => state.email;
